import React, {Fragment, useCallback, useContext, useState} from 'react';
import {Checkbox, FormControl, FormControlLabel, FormGroup, Grid, MenuItem, Select} from '@mui/material';

import {Controller, useFormContext} from "react-hook-form";

import {useOrderStyles} from "./index";
import {itemRowSpacing, SubTitle} from '../index';


const MultipleOrder = (props: any) => {
  const {disabledMultiple} = props;

  const {control, setValue, watch} = useFormContext();

  const nameOrderInterval = 'orderInterval';
  const nameOrderCount = 'orderCount';

  const minutes = ['0분', '10분', '20분', '30분', '40분', '50분'];
  const counts = ['2건', '3건', '4건', '5건', '6건', '7건', '8건', '9건', '10건'];

  const updateSidebar = useCallback((props) => {
    const {target} = props;
    if (target.name === "orderCount") {
      setValue("orderCount", target.value)
    }
    if (target.name === "orderInterval") {
      setValue("orderInterval", target.value)
    }

  }, [watch("orderCount"), watch("orderInterval")])

  return (
    <Grid container direction={'row'} spacing={3}>
      <Grid item xs={6}>
        <Controller  // control 로 감싸줘야 form 에서 데이터를 가져감
          control={control}
          name={nameOrderInterval}
          defaultValue={0}
          render={({field}) => (
            <FormControl disabled={disabledMultiple} fullWidth>
              <Select
                {...field}
                defaultValue={0}
                variant={"standard"}
                name={"orderInterval"}
                onChange={(e: any) => {
                  updateSidebar(e);
                  field.onChange(e);
                }}
              >
                {minutes.map((v: any, i: number) => (
                  <MenuItem key={i} value={i * 10}>{v}</MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />
      </Grid>
      <Grid item xs={6}>
        <Controller  // control 로 감싸줘야 form 에서 데이터를 가져감
          control={control}
          name={nameOrderCount}
          defaultValue={2} // 복수배차는 2건부터이기 때문에 기본값을 2로 셋팅
          render={({field}) => (
            <FormControl disabled={disabledMultiple} fullWidth>
              <Select
                {...field}
                defaultValue={2} // 복수배차는 2건부터이기 때문에 기본값을 2로 셋팅
                name={"orderCount"}
                variant={"standard"}
                onChange={(e: any) => {
                  updateSidebar(e);
                  field.onChange(e);
                }}
              >
                {counts.map((v: any, i: number) => (
                  <MenuItem key={i} value={i + 2}>{v}</MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />
      </Grid>
    </Grid>
  )
}

const Options = () => {
  const {control, setValue} = useFormContext();

  const [disabledMultiple, setDisabledMultiple] = useState<boolean>(true);

  const nameShuttle = 'optionShuttle';
  const nameMultiple = 'optionMultiple';
  const nameCashOnDelivery = 'optionCashOnDelivery';

  return (
        <Grid container direction="column">
          <Grid item>
            <FormControl component="fieldset">
              <FormGroup aria-label="position" row>
                <Controller
                  control={control}
                  name={nameShuttle}
                  render={({field}) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          value={field.value} // The DOM API casts this to a string.
                          onChange={(e: any) => {
                            const val = e.target.checked;
                            field.onChange(e);
                            setValue(nameShuttle, val); // DOM API 가 string 으로 컨버팅 하기 때문에 값을 다시 넣어준다.
                          }}
                          color="primary"
                        />
                      }
                      label="왕복"
                    />
                  )}
                />
                <Controller
                  control={control}
                  name={nameMultiple}
                  render={({field}) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          value={field.value} // The DOM API casts this to a string.
                          onChange={(e) => {
                            const val = e.target.checked;
                            field.onChange(e);
                            setValue(nameMultiple, val);
                            val ? setDisabledMultiple(false) : setDisabledMultiple(true);

                          }}
                          color="primary"
                        />
                      }
                      label="복수배차"
                    />
                  )}
                />
                <Controller
                  control={control}
                  name={nameCashOnDelivery}
                  render={({field}) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          value={field.value} // The DOM API casts this to a string.
                          onChange={(e) => {
                            const val = e.target.checked;
                            field.onChange(e);
                            setValue(nameCashOnDelivery, val);
                          }}
                          color="primary"
                        />
                      }
                      label="착불"
                    />
                  )}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid item>
            <MultipleOrder disabledMultiple={disabledMultiple}/>
          </Grid>
        </Grid>
  )
}

export default function FreightOption() {
  const classes = useOrderStyles();

  const title = '옵션';
  return (
    <Fragment>
      <SubTitle>{title}</SubTitle>
      <Grid container direction="column" spacing={itemRowSpacing}>
        <Grid item className={classes.firstRow}>
          <Options/>
        </Grid>
      </Grid>
    </Fragment>
  )
}